import IMask from "imask";
import $ from "jquery";

window.applyMasks = function () {

  function applyMask(input, maskOptions) {
    if (input.imask) return;

    input.imask = IMask(input, maskOptions);
  }

  function dynamicMask(input) {
    applyMask(input, { mask: $(input).attr("imask") })
  }

  $(document).on("focus", "[imask]", function () {
    dynamicMask(this)
  });
  $('[imask').each(function () { dynamicMask(this) })

  $(document).on("focus", "[imask]", function () {
    dynamicMask(this)
  });
  $('[imask').each(function () { dynamicMask(this) })


  function numberMask(input) {
    applyMask(
      input,
      {
        mask: Number,
        thousandsSeparator: '.',  // any single char
        radix: ',',  // fractional delimiter
        mapToRadix: ['.'],  // symbols to process as radix });
      }
    )
  }
  $(document).on("focus", ".number-mask", function () {
    numberMask(this)
  })
  $('.number-mask').each(function () { numberMask(this) })

  function moneyMask(input) {
    applyMask(
      input,
      {
        mask: Number,
        scale: 2,  // digits after point, 0 for integers
        thousandsSeparator: '.',  // any single char
        padFractionalZeros: true,  // if true, then pads zeros at end to the length of scale
        radix: ',',  // fractional delimiter
        mapToRadix: ['.'],  // symbols to process as radix });
      }
    )
  }

  $(document).on("focus", ".money-mask", function () {
    moneyMask(this)
  })
  $('.money-mask').each(function () { moneyMask(this) })

  function phoneMask(input) {
    applyMask(
      input,
      {
        mask: [
          {
            mask: '(00) 00000-0000'
          },
          {
            mask: /^\d+$/
          }
        ]
      }
    )
  }

  $(document).on("focus", ".phone-mask", function () {
    phoneMask(this)
  })
  $('.phone-mask').each(function () { phoneMask(this) })
}

applyMasks()